var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/close-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/close-circle_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 11.9999C1.25 6.08566 6.08579 1.24988 12 1.24988C17.9142 1.24988 22.75 6.08566 22.75 11.9999C22.75 17.9141 17.9142 22.7499 12 22.7499C6.08579 22.7499 1.25 17.9141 1.25 11.9999ZM12 2.74988C6.91421 2.74988 2.75 6.91409 2.75 11.9999C2.75 17.0857 6.91421 21.2499 12 21.2499C17.0858 21.2499 21.25 17.0857 21.25 11.9999C21.25 6.91409 17.0858 2.74988 12 2.74988Z",
    fill: "#FF6551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3622 8.63959C15.6551 8.93248 15.6551 9.40736 15.3622 9.70025L9.70221 15.3603C9.40931 15.6531 8.93444 15.6531 8.64154 15.3603C8.34865 15.0674 8.34865 14.5925 8.64154 14.2996L14.3015 8.63959C14.5944 8.3467 15.0693 8.3467 15.3622 8.63959Z",
    fill: "#FF6551"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.64154 8.63959C8.93444 8.3467 9.40931 8.3467 9.70221 8.63959L15.3622 14.2996C15.6551 14.5925 15.6551 15.0674 15.3622 15.3603C15.0693 15.6531 14.5944 15.6531 14.3015 15.3603L8.64154 9.70025C8.34865 9.40736 8.34865 8.93248 8.64154 8.63959Z",
    fill: "#FF6551"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedClose);
export default __webpack_public_path__ + "static/media/selected-close.9b5489b63dbb13abd481a754fc2732b5.svg";
export { ForwardRef as ReactComponent };